import { render } from "./AssistanceAlertModal.vue?vue&type=template&id=39e51af9&scoped=true"
import script from "./AssistanceAlertModal.vue?vue&type=script&lang=js"
export * from "./AssistanceAlertModal.vue?vue&type=script&lang=js"

import "./AssistanceAlertModal.vue?vue&type=style&index=0&id=39e51af9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e51af9"],['__file',"AssistanceAlertModal.vue"]])

export default __exports__